<template>
  <base-section
    id="equipment"
    title="設備紹介"
    subtitle="プロフェッショナルな施術に必要な設備を完備"
  >
    <div class="equipment-section">
      <div class="equipment-grid">
        <div v-for="item in equipmentItems" :key="item.id" class="equipment-item">
          <div class="equipment-item__image">
            <img :src="item.image" :alt="item.title" />
          </div>
          <div class="equipment-item__content">
            <h4 class="equipment-item__title">{{ item.title }}</h4>
            <p class="equipment-item__description">{{ item.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </base-section>
</template>

<script>
import BaseSection from '@/components/common/BaseSection.vue';

export default {
  name: 'EquipmentSection',
  components: {
    BaseSection
  },
  data() {
    return {
      equipmentItems: [
        {
          id: 1,
          title: 'エステベッド',
          description: '高級エステサロンで使用されている電動リクライニングベッド。お客様に最高のリラクゼーションを提供します。',
          image: require('@/assets/img/bed.jpg')
        },
        {
          id: 2,
          title: 'タオルウォーマー',
          description: '常に清潔で温かいタオルをご用意。衛生管理も万全です。',
          image: require('@/assets/img/warmer.jpg')
        },
        {
          id: 3,
          title: 'パーテーション',
          description: 'プライバシーに配慮した個室空間。落ち着いた雰囲気で施術に集中できます。',
          image: require('@/assets/img/partition.jpg')
        },
        {
          id: 4,
          title: '冷蔵庫',
          description: 'お客様用のドリンクや化粧品の保管にご利用いただけます。',
          image: require('@/assets/img/fridge.jpg')
        },
        {
          id: 5,
          title: '音響設備',
          description: 'Bluetooth対応スピーカー完備。お好みのBGMで空間を演出できます。',
          image: require('@/assets/img/music.jpg')
        },
        {
          id: 6,
          title: 'その他備品',
          description: 'ガウン、スリッパ、アメニティなど、サロン運営に必要な備品を完備しています。',
          image: require('@/assets/img/gown.jpg')
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '@/styles/mixins.scss';

.equipment-section {
  .equipment-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: $spacing-xl;
    
    @include media-breakpoint-down(lg) {
      grid-template-columns: repeat(2, 1fr);
    }
    
    @include media-breakpoint-down(sm) {
      grid-template-columns: 1fr;
    }
  }
  
  .equipment-item {
    background: $white;
    border-radius: $radius-lg;
    overflow: hidden;
    box-shadow: $shadow-sm;
    transition: all $transition-base;
    
    &:hover {
      transform: translateY(-4px);
      box-shadow: $shadow-lg;
      
      .equipment-item__image img {
        transform: scale(1.05);
      }
    }
    
    &__image {
      @include aspect-ratio(4, 3);
      overflow: hidden;
      background-color: $gray-100;
      
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform $transition-slow;
      }
    }
    
    &__content {
      padding: $spacing-lg;
    }
    
    &__title {
      font-size: $font-size-xl;
      font-weight: 600;
      color: $primary-color;
      margin-bottom: $spacing-sm;
    }
    
    &__description {
      font-size: $font-size-md;
      color: $gray-600;
      line-height: 1.6;
      margin: 0;
    }
  }
}
</style>